export default defineNuxtPlugin(() => {
  const { addSuccess } = useNotifications()
  const route = useRoute()
  if (route.query['no-track'] === undefined) return

  addSuccess('Success', 'Your request has been submitted.')
})
